import cx from 'classnames';
import { Field, getIn } from 'formik';
import { FunctionComponent } from 'react';
import { toDateInputValue } from './dateInputUtils';

type Props = {
    disabled?: boolean;
    errors: any;
    hideError?: boolean;
    label?: string;
    maxDate?: Date | string;
    minDate?: Date | string;
    name: string;
    placeholder?: string;
    touched: any;
    values: any;
};

const DateField: FunctionComponent<Props> = ({ disabled, hideError, label, maxDate, minDate, name, placeholder, values, errors, touched }) => {
    const value = getIn(values, name);
    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);

    const normalizedValue = toDateInputValue(value);
    const normalizedMaxDate = toDateInputValue(maxDate);
    const normalizedMinDate = toDateInputValue(minDate);

    return (
        <div className="timefield">
            {label && (
                <label htmlFor={name} className="form-label  timefield__label">
                    {label}
                </label>
            )}
            <Field
                autoComplete="off"
                className={cx('form-control timefield__control', { 'is-invalid': error && isTouched }, { 'is-valid': !error && isTouched })}
                disabled={disabled}
                id={name}
                max={normalizedMaxDate || undefined}
                min={normalizedMinDate || undefined}
                name={name}
                placeholder={placeholder}
                type="date"
                value={normalizedValue}
            />
            {!hideError && error && isTouched && <div className="field-error text-danger">{error}</div>}
        </div>
    );
};

export default DateField;
